import { createBrowserRouter } from "react-router-dom";
import IndexLayout from "../layouts/IndexLayout";
import MainLayout from "../layouts/MainLayout";
import PagesLayaut from '../layouts/PagesLayaut';
import PagesLayautMobile from '../layouts/PagesLayautMobile';
import Productos from '../pages/Productos/Productos';
import Usuarios from '../pages/Usuarios/Usuarios';
import Banners from "./Banners/Banners";
import Main from "./Main/Main";
import Contacto from "./Contacto/Contacto";
import Categorias from "./Categorias/Categorias";
import Codigos from "./Codigos/Codigos";
import PageDetail from '../pages/PageDetail/PageDetail';
import PageProductos from "./PageProductos/PageProductos";
import Pedidos from "./Pedidos/Pedidos";
import ListaCategoria from "../components/ListaCategoria/ListaCategoria";
import PageProductosCatalogo from "./PageProductosCatalogo/PageProductosCatalogo";
import useScreenSize from "../utils/useScreenSize";

const getRoutes = (isMobile, logo) => {
    const commonRoutes = [
        {
            path: "/",
            element: <MainLayout logo={logo} />,
            children: [
                {
                    path: `dashboard`,
                    element: <Main />,
                },
                {
                    path: `dashboard/productos`,
                    element: <Productos />,
                },
                {
                    path: `dashboard/usuarios`,
                    element: <Usuarios />,
                },
                {
                    path: `dashboard/banners`,
                    element: <Banners />,
                },
                {
                    path: `dashboard/contacto`,
                    element: <Contacto />,
                },
                {
                    path: `dashboard/categorias`,
                    element: <Categorias />,
                },
                {
                    path: `dashboard/codigos`,
                    element: <Codigos />,
                },
                {
                    path: `dashboard/pedidos`,
                    element: <Pedidos />,
                },
            ],
        },
        {
            path: "/",
            element: <PagesLayaut logo={logo} />,
            children: [
                {
                    path: `producto/:idProducto/:producto`,
                    element: <PageDetail />,
                },
            ],
        },
    ];

    if (isMobile) {
        return [
            {
                path: "/",
                element: <ListaCategoria logo={logo} />,
            },
            ...commonRoutes,
            {
                path: "/",
                element: <PagesLayautMobile logo={logo} />,
                children: [
                    {
                        path: `productos`,
                        element: <PageProductosCatalogo />,
                    },
                ],
            },
        ];
    } else {
        return [
            {
                path: "/",
                element: <IndexLayout logo={logo} />,
            },
            ...commonRoutes,
            {
                path: "/",
                element: <PagesLayaut logo={logo} />,
                children: [
                    {
                        path: `productos`,
                        element: <PageProductos />,
                    },
                ],
            },
        ];
    }
};

// Componente que renderiza las rutas según el tamaño de pantalla
export const RouterWrapper = (logo) => {
    const { isMobile } = useScreenSize();
    const router = createBrowserRouter(getRoutes(isMobile, logo));
    return router;
};